import React from 'react';
import { ActivityIndicator } from '@/components/activity-indicator';
import { createDrawerContext } from './drawer-context';
import { DrawerComponentProps } from '@/components/drawer';
import { OrderDrawerManager } from '@/components/order-drawer/order-drawer-manager';
import { QuantityMapType } from '@/screens/new-order/hooks/use-quantity-reducer';
import { StyleSheet, View } from 'react-native';

export const DRAWER_WIDTH = 500;

export interface OrderDrawerExtendedState {
  initialQuantityMap?: QuantityMapType;
  onSubmitSmartOrder?: () => void;
  smartOrderUUID?: string;
}

const DrawerComponent: React.FC<
  DrawerComponentProps<OrderDrawerExtendedState>
> = ({ onClose, open }) => {
  const { setCloseable, setCloseCallback } = useOrderDrawerContext();

  return open ? (
    <OrderDrawerManager
      closeDrawer={onClose}
      setCloseable={setCloseable}
      setCloseCallback={setCloseCallback}
    />
  ) : (
    <View style={styles.centered}>
      <ActivityIndicator />
    </View>
  );
};

const styles = StyleSheet.create({
  centered: {
    flex: 1,
    justifyContent: 'center',
  },
});

const {
  DrawerContext,
  DrawerContextProvider,
  useDrawerContext,
  useMaybeDrawerContext,
} = createDrawerContext<OrderDrawerExtendedState>({
  ContentComponent: DrawerComponent,
  position: 'right',
  width: DRAWER_WIDTH,
});

export const OrderDrawerContext = DrawerContext;
export const OrderDrawerContextProvider = DrawerContextProvider;
export const useOrderDrawerContext = useDrawerContext;
export const useMaybeOrderDrawerContext = useMaybeDrawerContext;
